const cachedTimezoneList = () => [
  {
    header: 'Pacific Standard',
    key: 3,
    subtitle: 'GMT -8',
    tzCode: 'America/Los_Angeles',
  },
  {
    header: 'Mountain Standard',
    key: 4,
    subtitle: 'GMT -7',
    tzCode: 'America/Denver',
  },
  {
    header: 'Central Standard',
    key: 5,
    subtitle: 'GMT -6',
    tzCode: 'America/Chicago',
  },
  {
    header: 'Eastern Standard',
    key: 6,
    subtitle: 'GMT -5',
    tzCode: 'America/New_York',
  },
  {
    header: 'Atlantic Standard',
    key: 7,
    subtitle: 'GMT -4',
    tzCode: 'America/Halifax',
  },
  {
    header: 'Argentine Time',
    key: 8,
    subtitle: 'GMT -3',
    tzCode: 'America/Argentina/Buenos_Aires',
  },
  {
    header: 'Fernando de Noronha Time',
    key: 9,
    subtitle: 'GMT -2',
    tzCode: 'America/Noronha',
  },
  {
    header: 'Azores Time',
    key: 10,
    subtitle: 'GMT -1',
    tzCode: 'Atlantic/Azores',
  },
  {
    header: 'Greenwich Mean Time',
    key: 11,
    subtitle: 'GMT 0',
    tzCode: 'Europe/London',
  },
  {
    header: 'Central European Time',
    key: 12,
    subtitle: 'GMT +1',
    tzCode: 'Europe/Berlin',
  },
  {
    header: 'Eastern European Time',
    key: 13,
    subtitle: 'GMT +2',
    tzCode: 'Europe/Sofia',
  },
  {
    header: 'Arabia Standard Time',
    key: 14,
    subtitle: 'GMT +3',
    tzCode: 'Asia/Baghdad',
  },
  {
    header: 'Moscow Standard Time',
    key: 14,
    subtitle: 'GMT +4',
    tzCode: 'Europe/Moscow',
  },
  {
    header: 'Gulf Standard Time',
    key: 15,
    subtitle: 'GMT +4',
    tzCode: 'Asia/Dubai',
  },
  {
    header: 'Pakistan Time',
    key: 16,
    subtitle: 'GMT +5',
    tzCode: 'Asia/Karachi',
  },
  {
    header: 'India Standard Time',
    key: 17,
    subtitle: 'GMT +5.5',
    tzCode: 'Asia/Colombo',
  },
  {
    header: 'Bangladesh Time',
    key: 18,
    subtitle: 'GMT +6',
    tzCode: 'Asia/Dhaka',
  },
  {
    header: 'Indochina Time',
    key: 19,
    subtitle: 'GMT +7',
    tzCode: 'Asia/Bangkok',
  },
  {
    header: 'China & Taiwan Time',
    key: 20,
    subtitle: 'GMT +8',
    tzCode: 'Asia/Shanghai',
  },
  {
    header: 'Japan & Korea Time',
    key: 21,
    subtitle: 'GMT +9',
    tzCode: 'Asia/Tokyo',
  },
  {
    header: 'Australia Eastern Standard Time',
    key: 22,
    subtitle: 'GMT +10',
    tzCode: 'Australia/Sydney',
  },
  {
    header: 'Solomon Time',
    key: 23,
    subtitle: 'GMT +11',
    tzCode: 'Pacific/Noumea',
  },
  {
    header: 'New Zealand Standard Time',
    key: 24,
    subtitle: 'GMT +12',
    tzCode: 'Pacific/Auckland',
  },
  {
    header: 'Midway Islands Time',
    key: 25,
    subtitle: 'GMT -11',
    tzCode: 'Pacific/Pago_Pago',
  },
  {
    header: 'Hawaii Standard Time',
    key: 26,
    subtitle: 'GMT -10',
    tzCode: 'Pacific/Honolulu',
  },
  {
    header: 'Alaska Standard Time',
    key: 27,
    subtitle: 'GMT -9',
    tzCode: 'America/Anchorage',
  },
]

export default cachedTimezoneList
